
export type CalendarProps = {
  events: CalendarEvent[]
  setEvents: (events: CalendarEvent[]) => void
  mode: Mode
  setMode: (mode: Mode) => void
  date: Date
  setDate: (date: Date) => void
  calendarIconIsToday?: boolean,
  
  vehicles: CalendarVehicle[],
  setVehicles: (vehicles: CalendarVehicle[]) => void,
  locations: CalendarLocation[],
  setLocations: (locations: CalendarLocation[]) => void,
  partners: CalendarPartner[],
  setPartners: (partners: CalendarPartner[]) => void,
  reservationStates: ReservationState[]
  setReservationStates: (states: ReservationState[]) => void,
}

export type CalendarContextType = CalendarProps & {
  newEventDialogOpen: boolean
  setNewEventDialogOpen: (open: boolean) => void
  manageEventDialogOpen: boolean
  setManageEventDialogOpen: (open: boolean) => void
  selectedEvent: CalendarEvent | null
  setSelectedEvent: (event: CalendarEvent | null) => void

  locations: CalendarLocation[]
  setLocations: (locations: CalendarLocation[]) => void
  partners: CalendarPartner[]
  setPartners: (partners: CalendarPartner[]) => void
  vehicles: CalendarVehicle[]
  setVehicles: (vehicles: CalendarVehicle[]) => void
  reservationStates: ReservationState[]
  setReservationStates: (states: ReservationState[]) => void
}
export type CalendarEvent = {
  id: string
  title: string
  color: string
  start: Date
  end: Date

  // reservation details
  vehicleId: number
  pickup: string
  pickupId: number
  pickup_latitude?: number
  pickup_longitude?: number
  dropoff: string
  dropoffId: number
  dropoff_latitude?: number
  dropoff_longitude?: number
  partnerId?: number
  status: string
  notes?: string
  customerName?: string
  customerPhone?: string
  customerEmail?: string
  price?: number
  commission?: number // do we need to save commission amount for each reservation?
  discount?: number
  discountType: "percentage" | "fixed"
}

export type CalendarVehicle = {
  id: number,
  name: string,
  totalPrice?: number // total price for the vehicle, if applicable
}

export type CalendarLocation = {
  id: number,
  name: string,
};

export type CalendarPartner = {
  id: number,
  name: string,
  commission: number,
};

export type ReservationState = {
  value: string
  label: string
  color: string
};

export const calendarModes = ['day', 'week', 'month'] as const
export type Mode = (typeof calendarModes)[number]
